export default __webpack_public_path__ + "images/dcn_a1ab5f.svg";